import { getHeightAvailableConfig } from './getHeightAvailableConfig'

export const observeHeightAvailable = (el: HTMLElement) => getHeightAvailableConfig()?.addElement(el)
